<automata-variable-menu
  [ngClass]="{ 'galaxy-compat': useGalaxyCompat }"
  (variableSelected)="variableSelectedEvent($event)"
  [partnerId]="automationVariableMenuService.automation.namespace"
  [extraMenuItems]="
    automationVariableMenuService.variablesFromPrecedingStepsForDataTypes$(
      supportedDataTypes,
      dontIncludeDefaultCategories,
      includeRepeatedParams
    ) | async
  "
></automata-variable-menu>
